import style from "./CartSummary.module.css"
import {useTranslation} from "react-i18next";
import Skeleton from 'react-loading-skeleton'
import {CartSummaryProps} from "../Interface";
import PaymentInfoItem from "../PaymentInfoItem/PaymentInfoItem";
import 'react-loading-skeleton/dist/skeleton.css'
import {mustache} from "../../../Helpers/functions";
import i18n from "../../../i18n";
import CouponForm from "../../Coupon/CouponForm/CouponForm";
import React from "react";
import PaymentInfoItemDynamic from "../PaymentInfoItem/PaymentInfoItemDynamic";

const CartSummary = (props: CartSummaryProps) => {

    const {t} = useTranslation()
    const hasDiscount = !!Math.ceil(Number(props.summary.discount))
    const hasTax = !!Math.ceil(Number(props.summary.tax))
    const discountPer =props.summary.discountPercentage
    const taxPer = props.summary.taxPercentage
    return (
        props.shortCartSummary ? <div className={`${style.shortSummery_container}`}>
            <div dir={i18n.language=='en'?'ltr':'rtl'} className={`${style.shortSummery_row}`}>
                <div className={`${style.shortSummery_col}`}>
                    <div className={`${style.shortSummery_font_header}`}>{t('payment.cart.total')}</div>
                </div>
                <div className={`${style.shortSummery_col}`}>
                    <div
                        className={`${style.shortSummery_font_header_lg}`}>{props.summary.total} {props.summary.currency}</div>
                </div>
            </div>
        </div> : <div dir={i18n.language=='en'?'ltr':'rtl'} className={style.container}>
            {props.loading ? <Skeleton width={"100%"} height={"150px"} style={{marginBottom:"5px"}}/> :
                <div className={style.wrapper}>
                    {!props.cart?.isPaymentLink && props.withCoupon && <div>
                        <div className={`${style.title}`}>
                            {t('coupon.main.title')}
                        </div>
                        <CouponForm reloadPayment={props.reloadPayment} cart={props.cart}
                                    handleCart={props.handleCart}/>
                    </div>
                    }
                    {props.title &&  <div className={`${style.title}`}>
                        {t(props.title)}
                    </div> }

                    <div className={`${style.text_box}`}>

                        {/* {
                            <PaymentInfoItem
                                label={t('total.subtotal')}
                                value={props.summary.subTotal}
                                type={''}
                                extra={props.summary.currency}
                                isTotal={false}
                            />
                        }

                        { discountPer && <PaymentInfoItem
                            label={mustache(t('total.discount'), {percent: discountPer})}
                            value={props.summary.discount}
                            type={''}
                            extra={props.summary.currency}
                            isTotal={false}

                        />}

                        {
                            taxPer &&
                            <PaymentInfoItem
                                label={mustache(t('total.tax'), {percent: taxPer})}
                                value={props.summary.tax}
                                type={''}
                                extra={props.summary.currency}
                                isTotal={false}

                            />
                        } */}

                        {props.summary.detailsList.map(item => {
                            if (item.type === 'divider') {
                                return <hr className={`${style.separator_100}`} />;
                            }
                            // Check if the value contains '*'
                            const isBold = item.value.includes('*');
                            // Remove '*' from the value
                            // const cleanedValue = item.value.replace(/\*/g, '');
                            const cleanedValue = item.value
                            
                            return <PaymentInfoItemDynamic
                                label={item.label}
                                value={cleanedValue} // Use cleaned value
                                type={'normal'} // Set type conditionally
                                isBold={isBold}
                                info={item.info ?? null} 
                            />
                        })}
                    </div>
                    
                    {/* {props.summary.total && <hr className={`${style.separator}`}/>}
                    <div className={style.total_text_box}>
                        <div>
                            <PaymentInfoItem
                                label={t('total.total')}
                                value={props.summary.total}
                                type={'bold'}
                                extra={props.summary.currency}
                                isTotal={true}

                            />
                        </div>
                    </div> */}
                </div>}

        </div>

    )
}

export default CartSummary